export class KoExtensions {
	static observable<T>(value?: T): KnockoutObservable<T> {
		var obs = ko.observable<T>().extend({
			stringEmptyNull: true
		});
		if (value != undefined) {
			obs(value);
		}
		return obs;
	}
}
